
import { Options, Vue } from 'vue-class-component';
import NavigationService from "@/services/NavigationService";
import LoginForm from '@/components/LoginForm.vue';
import GuestShroud from "@/components/helpers/GuestShroud.vue";

@Options({
    components: {
        GuestShroud,
        LoginForm,
    },
})
export default class App extends Vue {
    onLogin() {
        NavigationService.navigateLoginSuccessful();
    }
}
